import { formatDateTimeIst } from "../common/dateTimeIst";

export const TRACKED_ACTIVITY_LABELS = {
  mouse: "Mouse",
  keyboard: "Keyboard",
  click: "Click",
  scroll: "Scroll",
};

export const ACTIVITY_EVENT_LABELS = {
  ...TRACKED_ACTIVITY_LABELS,
  activity: "General",
  tab_visible: "Tab visible",
  tab_hidden: "Tab hidden",
  idle: "Idle",
  idle_ack: "Active again",
  pause: "Paused",
  resume: "Resumed",
  check_in: "Check in",
  check_out: "Check out",
  auto_check_out: "Auto check out",
};

export const formatActivityEventLabel = (type) =>
  ACTIVITY_EVENT_LABELS[type] || type || "—";

export const formatTrackedActivities = (trackedActivities = []) => {
  if (!Array.isArray(trackedActivities) || !trackedActivities.length) return [];
  return trackedActivities.map((item) => ({
    type: item.type,
    label: formatActivityEventLabel(item.type),
    lastOccurredAt: item.lastOccurredAt,
    count: item.count,
  }));
};

export const formatActivityLastOccurred = (value) => formatDateTimeIst(value);
